<template>
  <div class="super-admin-wrap">
    <modal
      v-if="showDomain"
      @close-modal="showDomain=false"
    >
      <add-or-edit-domain
        :fair="selectedFair"
        @close-modal="showDomain=false"
      ></add-or-edit-domain>
    </modal>
    <modal
      v-if="showAddFair"
      @close-modal="showAddFair=false"
    >
      <add-fair
        :servers="servers"
        @close-modal="showAddFair=false"
      ></add-fair>
    </modal>
    <div class="form-wrap">
      <h1>Fairs</h1>
      <div class="add-fair-button-wrap">
        <button @click="openAddFair">Add Fair</button>
      </div>
      <div class="fairs-table">
        <div class="table-header">
          <div class="fair-code">Fair code</div>
          <div class="fair-alias">Fair name</div>
          <div class="fair-proto-date">Proto date</div>
          <div class="fair-edit"></div>
        </div>
        <div class="each-fair"
          v-for="(fair, index) in fairs"
          :key="index"
        >
          <div class="fair-code">{{fair.sit_name}}</div>
          <div class="fair-alias">{{fair.sit_alias}}</div>
          <div class="fair-proto-date">{{ fair.sit_proto_date ? fair.sit_proto_date : '/'}}</div>
          <div class="fair-edit"><button @click="setSelectedFairAndOpenModal(fair)">Edit Domain</button></div>
          <div class="fair-edit"><button @click="goTo(fair.sit_url)">Go</button></div>
          <div class="fair-delete"><button @click="confirmDelete(fair)">Delete Domain</button></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import AddOrEditDomain from '../../components/admin/super-admin/AddOrEditDomain';
import AddFair from '../../components/admin/super-admin/AddFair';
import AdminMixin from '@/views/admin-pages/adminMixin.js'
export default {
  mixins: [
    AdminMixin
  ],
  components: {
    AddOrEditDomain,
    AddFair
  },
  data () {
    return {
      fairs: [],
      selectedFair: {},
      servers: [],
      fairId: null,
      showDomain: false,
      showAddFair: false
    }
  },
  mounted () {
    this.init();
  },
  methods: {
    async init () {
      this.startLoading();
        await this.getSites();
        await this.getServers();
      this.stopLoading();
    },
    async getSites () {
      let apiObj = {
        api: api.getSites,
        onError: () => this.stopLoading()
      }

      const data = await this.apiCall(apiObj);
      if (data) {
        this.fairs = await this.mapProtoDatesToSites(data.data.sites);
      }
    },
    async mapProtoDatesToSites (sites) {
      for (let i = 0; i < sites.length; i++) {
        const fullApiPath = sites[i].sit_url + '/api/admin/meta/sites/proto'
        const apiObj = {
          api: api.getSiteProtoDate,
          params: fullApiPath,
          onError: () => this.stopLoading()
        }
        const data = await this.apiCall(apiObj);
        if (data) {
          sites[i].sit_proto_date = data.version
        }
      }
      return sites;
    },
    async getServers () {
      let apiObj = {
        api: api.getServers,
        onError: () => this.stopLoading()
      }

      const data = await this.apiCall(apiObj);
      if (data) {
        this.servers = data.data.servers;
      }
    },
    confirmDelete (id) {
      this.fairId = id;
      this.confirmAction(this.deleteFair, this.$t('superAdmin.deleteFair'));
    },
    async deleteFair () {
      let apiObj = {
        api: api.deleteFair,
        params: {
          sit_id: this.fairId
        }
      }
      const data = await this.apiCall(apiObj);
      if (data) {
        this.showSuccessMessage(this.$t('superAdmin.deleteSuccessMessage'))
        await this.init();
      }
    },
    setSelectedFairAndOpenModal (fair) {
      this.selectedFair = fair;
      this.showDomain = true;
    },
    openAddFair () {
      this.showAddFair = true;
    },
    goTo (link) {
      const win = window.open(link, '_blank');
      win.focus();
    }
  }
}
</script>

<style scoped>
* {
  box-sizing: border-box;
}
h1 {
  margin: 0;
}
.super-admin-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 1% 10% 1% 3%;
  font-size: 18px;
}
.form-wrap {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 80%;
  border-radius: 20px;
  padding: 0 20px 20px 20px;
}
.add-fair-button-wrap {
  display: flex;
  justify-content: flex-end;
  width: 100%;
  margin: 10px 0;
}
.fairs-table {
  display: flex;
  flex-direction: column;
  width: 100%;
  border-radius: 20px;
  overflow: hidden;
}
.table-header {
  background: #343434;
  color: #FFF;
}
.each-fair {
  background: #FFF;
  border-bottom: 1px solid #e5e5e5;
}
.table-header,
.each-fair {
  display: flex;
  width: 100%;
}
.fair-code,
.fair-alias,
.fair-edit,
.fair-delete,
.fair-proto-date {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 16.66%;
  padding: 5px 10px;
}
.fair-delete button{
  background: var(--button-color-bright-red);
}
button {
  cursor: pointer;
  display: flex;
  flex-direction: row;
  align-items: center;
  white-space: nowrap;
  outline: none;
  border: none;
  padding: 10px 20px;
  border-radius: 100px;
  font-weight: 600;
  background: var(--button-color-blue);
  color: white;
}
</style>